import React from "react";
import Modal from "../../../../../shared-components/css-modules/toyota/organisms/Modal";
import type { ModalViewType } from "../../../../../../../common-deprecated/types/CommonTypes";
import type { PackExtrasModalType } from "../../../../utils/modalConstants";
import Text from "../../../../../shared-components/css-modules/toyota/atoms/Text";
import Button from "../../../../../shared-components/css-modules/toyota/atoms/Button";
import styles from "./PackExtraModal.module.scss";
import { trackOptionsBasketExtraAdd } from "../../../../utils/tracking";
import { addExtra, addPack } from "../../../../redux/slices/CarConfigBasketSlice";
import { useCarConfigDispatch } from "../../../../redux/store";
import { addNotification } from "../../../../../../../common-deprecated/redux/actions/NotificationActions";
import { CarConfigLabel, useCarConfigLabel } from "../../../../utils/labelUtils";
import { setPackAddedByExtra } from "../../../../redux/slices/CarConfigNavigationSlice";

const PackExtraModal = (props: ModalViewType<PackExtrasModalType>): JSX.Element => {
    const dispatch = useCarConfigDispatch();
    const { show, close, modalSettings } = props;
    const { extra, pack } = modalSettings;
    const notificationPackAdded = useCarConfigLabel("carConfigA11yPackAdded", { pack: pack.name });

    const addExtraClick = (): void => {
        trackOptionsBasketExtraAdd();
        dispatch(addExtra({ extra, automatic: false }));

        close();
    };

    const addPackClick = (): void => {
        dispatch(addPack({ pack, selectedPacks: [], selectedExtras: [], automatic: false }));
        dispatch(
            addNotification([
                {
                    title: notificationPackAdded,
                    srOnly: true,
                    action: {
                        closeButton: true,
                    },
                },
            ]),
        );

        dispatch(setPackAddedByExtra(pack));
        close();
    };
    return (
        <Modal open={show} onRequestClose={close} variant="content-height">
            <Text tag="h2" variant="header-regular" className={styles.title}>
                <CarConfigLabel label="carConfigExtraPartOfPackTitle" params={{ pack: pack.name }} />
            </Text>
            <Text tag="p" variant="apheleia-h4">
                <CarConfigLabel label="carConfigExtraPartOfPackSubtitle" />
            </Text>

            <ul className={styles["option-list"]}>
                <li>
                    <Text variant="apheleia-h4">
                        <CarConfigLabel useHTML label="carConfigOnlyAddExtra" />
                    </Text>
                </li>
                <li>
                    <Text variant="apheleia-h4">
                        <CarConfigLabel useHTML label="carConfigOnlyAddPack" />
                    </Text>
                </li>
            </ul>

            <div className={styles["cta-buttons"]}>
                <Button onClick={addExtraClick} variant="btn-default" className={styles["add-button"]}>
                    <CarConfigLabel label="carConfigAddExtraToBasket" />
                </Button>

                <Button onClick={addPackClick} variant="btn-secondary" className={styles["add-button"]}>
                    <CarConfigLabel label="carConfigAddPackToBasket" />
                </Button>
            </div>
        </Modal>
    );
};

export default PackExtraModal;
